import {SODeleteProcessRole} from '../../core/process-role/so-delete-process-role';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeleteProcessRole extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeleteProcessRole;
}